import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Avatar, DatePicker } from "antd";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import "react-datepicker/dist/react-datepicker.css";
import locale from "antd/es/date-picker/locale/pt_BR";
import dayjs from "dayjs";
import { startOfMonth, endOfMonth, addMonths } from "date-fns";

import LoadingScreen from "../util/LoadingScreen";
import CustomPagination from "../util/CustomPagination";
import UsersSearch from "../dashboard/calender/UsersSearch";

const { RangePicker } = DatePicker;

const nextMonthStart = dayjs(startOfMonth(addMonths(new Date(), 1)));
const nextMonthEnd = dayjs(endOfMonth(addMonths(new Date(), 1)));

const DutyMigrateUserModal = ({ show, arraySelect, handleClose }) => {
    const [deletingId, setDeletingId] = useState(null);

    const [filters, setFilters] = useState({
        user_id: ""
    });

    const [localArray, setLocalArray] = useState([]);
    const [loading, setLoading] = useState(false);

    // Paginação
    const itemsPerPage = 5;
    const [currentPage, setCurrentPage] = useState(1);

    const totalItems = localArray.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const paginatedItems = localArray.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    useEffect(() => {
        if (show) {
            setLocalArray(arraySelect); // cópia local
            setCurrentPage(1);
        }
    }, [show, arraySelect]);

    const save = async () => {

        setLoading(true);

        const payload = {
            id: localArray.map(item => item.id),
            user_id: filters.user_id,
        };

        try {
            const response = await ApiService.send(
                "put",
                `${process.env.REACT_APP_URL_API}duty/update_duty_scale`,
                payload,
                true
            );

            if (response.code === 200) {
                const { updated = [], not_updated = [], success_count, failed_count } = response.data;

                const updatedMap = new Map();
                updated.forEach(item => updatedMap.set(item.id, item.message));
                not_updated.forEach(item => updatedMap.set(item.id, item.reason));

                const updatedArray = localArray.map(item => ({
                    ...item,
                    message: updatedMap.get(item.id) || null
                }));

                setLocalArray(updatedArray);

                Swal.fire({
                    title: "Alteração de Usuários nos Plantões",
                    html: `
            <p><strong>Sucesso:</strong> ${success_count}</p>
            <p class="text-danger"><strong>Falha:</strong> ${failed_count}</p>
        `,
                    icon: "success",
                    confirmButtonText: "OK",
                }).then();
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteItem = async (id) => {
        setDeletingId(id); // Ativa o estado de carregamento do botão clicado

        try {
            // Simulando tempo de exclusão se necessário
            await new Promise(resolve => setTimeout(resolve, 500));

            if (localArray.length > 1) {
                const filtered = localArray.filter(item => item.id !== id);
                setLocalArray(filtered);

                if ((currentPage - 1) * itemsPerPage >= filtered.length && currentPage > 1) {
                    setCurrentPage(currentPage - 1);
                }
            } else {
                Swal.fire("Erro!", "Nenhum plantão selecionado!", "error").then(() => {
                    handleClose();
                });
            }
        } catch (err) {
            console.error("Erro ao excluir:", err);
        } finally {
            setDeletingId(null); // Libera o botão
        }
    };


    const getOrderMonthText = (orderMonth) => {
        switch (orderMonth) {
            case 0: return "Toda Semana";
            case 1: return "1ª Semana";
            case 2: return "2ª Semana";
            case 3: return "3ª Semana";
            case 4: return "4ª Semana";
            case 5: return "5ª Semana";
            default: return "Semana não especificada";
        }
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Migrar Plantão</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                        {/* Filtro de Data */}
                        <div className="col-md-12 form-group">
                            <UsersSearch

                                onUserSelect={(user) =>
                                    setFilters((prevFilters) => ({
                                        ...prevFilters,
                                        user_id: user?.value || "",
                                    }))
                                }
                            />
                        </div>

                        {/* Lista compacta */}
                        <div className="table-responsive">
                            <table className="table table-bordered table-hover align-middle">
                                <thead className="table-light">
                                <tr>
                                    <th>Profissional</th>
                                    <th>Local</th>
                                    <th>Data / Horário</th>
                                    <th>Departamento</th>
                                    <th>Ações/Resultados</th>
                                </tr>
                                </thead>
                                <tbody>
                                {paginatedItems.map((duty) => (
                                    <tr key={duty.id}>
                                        {/* Profissional */}
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <Avatar
                                                    src={duty.accept_user?.profile_image || process.env.REACT_APP_URL_STORAGE + 'src/perfil_icone.png'}
                                                    size={24}
                                                    className="me-2"
                                                />
                                                <div>
                                                    <strong>{duty.accept_user?.name || "Profissional não informado"}</strong><br/>
                                                    <small className="text-muted">
                                                        {duty.accept_user?.ddd && duty.accept_user?.phone
                                                            ? `(${duty.accept_user.ddd}) - ${duty.accept_user.phone}`
                                                            : 'Telefone não informado'}

                                                    </small>
                                                </div>
                                            </div>
                                        </td>

                                        {/* Hospital */}
                                        <td>
                                            <strong>{duty.hospital?.name || "Local não informado"}</strong><br/>
                                            <small className="text-muted">
                                                <i className="fa fa-map-marker-alt text-info me-1"></i>
                                                {duty.hospital?.city_name}, {duty.hospital?.uf}
                                            </small>
                                        </td>

                                        {/* Data e Horário */}
                                        <td>
                                            <i className="fa fa-calendar text-primary me-1"></i>
                                            {dayjs(duty.date_time).format("DD/MM/YYYY")}<br/>
                                            <i className="fa fa-clock text-primary me-1"></i>
                                            {dayjs(duty.date_time).format("HH:mm")} - {dayjs(duty.date_time_end).format("HH:mm")}
                                        </td>

                                        {/* Departamento */}
                                        <td>
                                            <i className="fa fa-stethoscope text-primary me-1"></i>
                                            {duty.department?.name || "Departamento não informado"}
                                        </td>

                                        {/* Ação */}
                                        <td>
                                            {duty.message ? (
                                                <div
                                                    className={`alert py-1 px-2 mb-0 ${duty.message.includes("sucesso") ? "alert-success" : "alert-danger"}`}
                                                    style={{fontSize: "12px"}}
                                                >
                                                    {duty.message}
                                                </div>
                                            ) : (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-danger"
                                                    onClick={() => handleDeleteItem(duty.id)}
                                                    disabled={deletingId === duty.id}
                                                >
                                                    {deletingId === duty.id ? (
                                                        <>
                                                            <span
                                                                className="spinner-border spinner-border-sm me-1"
                                                                role="status"
                                                                aria-hidden="true"
                                                            ></span>
                                                            Excluindo...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fa fa-trash me-1"></i>
                                                            Excluir
                                                        </>
                                                    )}
                                                </button>
                                            )}
                                        </td>

                                    </tr>
                                ))}

                                </tbody>
                            </table>
                        </div>

                    {/* Paginação com CustomPagination */}
                    <CustomPagination
                        pagination={{
                            current: currentPage,
                            total: totalItems,
                            perPage: itemsPerPage,
                            lastPage: totalPages
                        }}
                        onChange={(page) => setCurrentPage(page)}
                    />

                    <div className="modal-footer mt-5">
                        <button type="button" className="btn btn-secondary" onClick={() => handleClose()}>
                            <i className="fa fa-close"></i> Cancelar
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() =>save()}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    Migrando...
                                </>
                            ) : (
                                <>
                                    <i className="fa fa-rocket me-2"></i> Migrar Plantão
                                </>
                            )}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default DutyMigrateUserModal;
